import { useMemo } from 'react';
import { AuthCard } from '@/components/auth-card';
import { PageFooter } from '@/components/page-footer';

import { LocaleProvider, useLocale } from '@/lib/locale-context';
import { copyFor, messageFor } from '@/lib/messages';
import { InteractionFlow } from './interaction-flow';
import { ForgotPassword } from './recovery/forgot-password';
import { ResetPassword } from './recovery/reset-password';
import { matchRoute } from './routes';

export function App() {
  return (
    <LocaleProvider>
      <Routed />
    </LocaleProvider>
  );
}

function Routed() {
  const route = useMemo(
    () => matchRoute(window.location.pathname, window.location.search),
    [],
  );
  const { locale } = useLocale();

  if (route.name === 'interaction') {
    return <InteractionFlow uid={route.uid} />;
  }

  if (route.name === 'forgot-password') {
    return <ForgotPassword />;
  }

  if (route.name === 'reset-password') {
    return <ResetPassword token={route.token} />;
  }

  // `/error` is where the social callback sends a browser whose state was
  // unusable (expired at the provider, replayed, tampered): there is no
  // interaction to return to, so this terminal card — start again from the
  // app — is the honest answer. Unknown paths land on the same card: sign-in
  // always starts at an app or website, never at this origin.
  return (
    <AuthCard title={copyFor(locale).errorTitle} footer={<PageFooter />}>
      <p role="alert" className="text-sm leading-relaxed text-buds-muted">
        {messageFor('interaction_not_found', locale)}
      </p>
    </AuthCard>
  );
}
